import Vue from 'vue'
import Vuex from 'vuex'
import { AuthModule } from "./modules/auth";
import { SettingsModule } from "./modules/settings";
import { DashboardModule } from "./modules/dashboard";
import { StatsUruchomieniaModule } from "./modules/statsUruchomienia";
import { StatsPobraniaModule } from "./modules/statsPobrania";
import { StatsDeklaracjeModule } from "./modules/statsDeklaracje";

const debug = process.env.NODE_ENV !== 'production';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
            AuthModule: new AuthModule(),
            SettingsModule: new SettingsModule(),
            DashboardModule: new DashboardModule(),
            StatsUruchomieniaModule: new StatsUruchomieniaModule(),
            StatsPobraniaModule: new StatsPobraniaModule(),
            StatsDeklaracjeModule: new StatsDeklaracjeModule()
    },
    strict: debug
})

